// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"rba-z","vrsnlCrossSiteLabel":"sba-z"};